<template>
  <div>
    <simple-table :data="$store.state.admin.registrations" :columns="stColumns" :show-row-numbers="true" />
  </div>
</template>

<script>
    import SimpleTable from "../simple-table/SimpleTable";
    export default {
      name: "Registrations",
      components: {SimpleTable},
      data: function() {
        return {
          stColumns: [
            {header: "created", field: "Created", format:"dateTime"},
            {header: "e-mail", field: "Email"},
            {header: "activation code", field: "ActivationCode"},
            {header: "customer exists", field: "CustomerExists", format: "bool"},
            {header: "verification code", field: "ConfirmationCode", format:"emailVerificationLink"},
          ],
        }
      },
      async mounted() {
        await this.$store.dispatch('admin/listRegistrations')
      },
    }
</script>

<style scoped>

</style>
